import {
    checkModalValidationsForConfig,
    checkModalValidationsForTestPackage, checkTesseractAddTestPackageModalValidations,
    checkZancaSortAddTestPackageModalValidations
} from "./Validations";
import {ADTA_ASSET_TYPE, ADTF_ASSET_TYPE, COMMA, EMPTY_STRING, TESSERACT_ASSET_TYPE} from "./Constants";
import {getLocalizedMessage} from "./Localization";

const commonCSVValidation = (str, parser) => {
    if (str.indexOf("\n") === str.length) {
        return {error: "CSV file has no rows"}
    }
    const head = str.slice(0, str.indexOf("\n"))
    const header = head.replace(/\s/g,'').toLowerCase().split(',');
    const headerCheck = parser.FIELDS.reduce((result, val, index) => {
        return result && val.toLowerCase() === header[index]
    }, true);
    if (header.length !== parser.FIELDS.length || !headerCheck) {
        return {error: "CSV file headers are incorrect. Expected headers: " + JSON.stringify(parser.FIELDS), }
    }
    return str.slice(str.indexOf("\n") + 1).split("\n");
}

export const escapeDoubleQuotes = (data) => {
    return '"' + data.replace(/"/g, '\'') + '"';
}

export const SorterConfigCSVParser = {
    FIELDS: ["DestinationId", "InstallationType", "Locations"],
    SAMPLE: 'DestinationId,InstallationType,Locations\n4001,aisle,"A,1;B,1"\n4002,jackpot,Finger A',
    STRINGIFY: (assets) => {
        let res = "DestinationId,InstallationType,Locations\n";
        assets.forEach((asset) => {
            if(['jackpot', 'miss', 'recirculation'].includes(asset.installation.type)) {
                res += `${asset.bayId},${asset.installation.type},${asset.fingerName}\n`
            } else {
                let locationString = "";
                asset.installation.locations.forEach((location, index) => {
                    if(index) {
                        locationString += `;${location}`;
                    } else {
                        locationString += location;
                    }
                })
                res += `${asset.bayId},${asset.installation.type},"${locationString}"\n`
            }
        })
        return res;
    },
    PARSE: (str, mac) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, SorterConfigCSVParser);
        if (rows.error) {
            return rows;
        }

        // Process each row
        const sorterConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate sorter config from values
            const values = row.split(',');
            const config = {
                bayId: values[0].replace(/\s/g,''),
                installation: {
                    type: values[1].toLowerCase().replace(/\s/g,'')
                }
            }
            if (['miss','jackpot','recirculation'].includes(config.installation.type)) {
                config.fingerName = values[2].trim()
            } else {
                config.installation.locations = values.slice(2).join(',').toUpperCase().replace(/\s|"/g,'').split(';');
            }
            // Validate row
            const validateConfig = JSON.parse(JSON.stringify(config))
            if (validateConfig.installation.locations) {
                validateConfig.installation.locations = validateConfig.installation.locations.join(";")
            }
            if(!checkModalValidationsForConfig(validateConfig, mac, ADTA_ASSET_TYPE)) {
                console.log("ERROR = ", validateConfig);
                console.log("MAC = ", mac);
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }
            // Add to list
            sorterConfig.push(config);
        }
        return sorterConfig;
    }
}

export const ADTFSorterConfigCSVParser = {
    FIELDS: ["DestinationId", "SorterId", "InstallationType", "Locations"],
    SAMPLE: 'DestinationId,SorterId,InstallationType,Locations\nL01#0,1,cluster,"A"\nJP#0,1,miss,""',
    STRINGIFY: (assets) => {
        let res = "DestinationId,SorterId,InstallationType,Locations\n";
        assets.forEach((asset) => {
            if(['miss', 'jackpot', 'ov'].includes(asset.installation.type)) {
                res += `${asset.destinationId},${asset.sorterId},${asset.installation.type},""\n`
            } else {
                let locationString = "";
                asset.installation.locations.forEach((location, index) => {
                    if(index) {
                        locationString += `;${location}`;
                    } else {
                        locationString += location;
                    }
                })
                res += `${asset.destinationId},${asset.sorterId},${asset.installation.type},"${locationString}"\n`
            }
        })
        return res;
    },
    PARSE: (str, mac) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, ADTFSorterConfigCSVParser);
        if (rows.error) {
            return rows;
        }

        // Process each row
        const sorterConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate sorter config from values
            const values = row.split(',');
            const config = {
                destinationId: values[0].replace(/\s/g,''),
                sorterId: values[1].replace(/\s/g,''),
                installation: {
                    type: values[2].toLowerCase().replace(/\s/g,'')
                }
            }
            if (['miss', 'jackpot', 'ov'].includes(config.installation.type)) {
                config.installation.locations = [];
            } else {
                config.installation.locations = values.slice(3).join(',').toUpperCase().replace(/\s|"/g,'').split(';');
            }
            // Validate row
            if(!checkModalValidationsForConfig(config, mac, ADTF_ASSET_TYPE)) {
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }
            // Add to list
            sorterConfig.push(config);
        }
        return sorterConfig;
    }
}

export const TestConfigCSVParser = {
    FIELDS: ["Scannables", "SortZone"],
    SAMPLE: 'Scannables,SortZone\nTBA123456789,A1-1A\nTBA123456790,B1-1B',
    STRINGIFY: (assets) => {
        let res = "Scannables,SortZone\n";
        assets.forEach((asset) => {
            let scannablesString = "";
            asset.scannables.forEach((scannable, index) => {
                if(index) {
                    scannablesString += `;${scannable}`
                } else {
                    scannablesString += scannable;
                }
            });
            res += `${scannablesString},${asset.sortZone}\n`
        })
        return res;
    },
    PARSE: (str) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, TestConfigCSVParser);

        // Process rows
        const sorterConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate sorter config from values
            const values = row.replace(/\s/g,'').split(',');
            const config = {
                scannables: values[0].split(';'),
                sortZone: values[1]
            }
            // Validate row
            if(!checkModalValidationsForTestPackage(config)) {
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }
            // Add to list
            sorterConfig.push(config);
        }
        return sorterConfig;
    }
}

export const ZancaSortTestConfigCSVParser = {
    FIELDS: ["Scannables", "Destination"],
    SAMPLE: 'Scannables,Destination\nTBA123456789,BAG-TEST-01-ZS\nTBA123456790,BAG-TEST-02-ZS',
    STRINGIFY: (assets) => {
        let res = "Scannables,Destination\n";
        assets.forEach((asset) => {
            let scannablesString = "";
            asset.scannables.forEach((scannable, index) => {
                if(index) {
                    scannablesString += `;${scannable}`
                } else {
                    scannablesString += scannable;
                }
            });
            res += `${scannablesString},${asset.destination}\n`
        })
        return res;
    },
    PARSE: (str) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, ZancaSortTestConfigCSVParser);

        // Process rows
        const testConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate test config from values
            const values = row.replace(/\s/g,'').split(',');
            const config = {
                scannables: values[0].split(';'),
                destination: values[1]
            }
            // Validate row
            if(!checkZancaSortAddTestPackageModalValidations(config)) {
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }
            // Add to list
            testConfig.push(config);
        }
        return testConfig;
    }
}

export const TesseractStowConfigCSVParser = {
    FIELDS: ["ContainerType", "ContainerLabel"],
    SAMPLE: 'ContainerType,ContainerLabel\nSAMPLE_TYPE_01,A-1\nSAMPLE_TYPE_02,A-2',
    STRINGIFY: (assets) => {
        let res = "ContainerType,ContainerLabel\n";
        assets.forEach((asset) => {
            res += `${asset.containerType},${asset.containerLabel}\n`
        })
        return res;
    },
    PARSE: (str, mac) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, TesseractStowConfigCSVParser);

        // Process rows
        const stowConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate config from values
            const values = row.replace(/\s/g,'').split(',');
            const config  = {
                containerType: values[0],
                containerLabel: values[1]
            }

            // Validate row
            if(!checkModalValidationsForConfig(config, mac, TESSERACT_ASSET_TYPE)) {
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }

            // Add to list
            stowConfig.push(config);
        }
        return stowConfig;
    }
}

export const TesseractTestConfigCSVParser = {
    FIELDS: ["TrackingId","Scannables", "Destination"],
    SAMPLE: 'TrackingId,Scannables,Destination\nTBA123456789,SAMP_TEST_001;TBA123456789,A-1\nTBA123456790,TBA123456790,A-2',
    STRINGIFY: (assets) => {
        let res = "TrackingId,Scannables,Destination\n";
        assets.forEach((asset) => {
            let scannablesString = "";
            asset.scannables.forEach((scannable, index) => {
                if(index) {
                    scannablesString += `;${scannable}`
                } else {
                    scannablesString += scannable;
                }
            });
            res += `${asset.trackingId},${scannablesString},${asset.destination}\n`
        })
        return res;
    },
    PARSE: (str) => {
        // Get rows after common validation
        const rows = commonCSVValidation(str, TesseractTestConfigCSVParser);

        // Process rows
        const testConfig = [];
        for (let index = 0; index < rows.length; index++) {
            // Handle empty rows
            const row = rows[index];
            if (!row) {
                continue;
            }
            // Generate test config from values
            const values = row.replace(/\s/g,'').split(',');
            const config = {
                trackingId: values[0],
                scannables: values[1].split(';'),
                destination: values[2]
            }
            // Validate row
            if(!checkTesseractAddTestPackageModalValidations(config)) {
                return {error: "Values of row number " + (index+1) + " are invalid"}
            }
            // Add to list
            testConfig.push(config);
        }
        return testConfig;
    }
}

export const DivertConfigCSVParser = {
    FIELDS: ["DivertCode", "Clusters"],
    SAMPLE: 'DivertCode,Clusters\n10,A;B',
    STRINGIFY: (assets) => {
        let res = "DivertCode,Clusters\n";
        assets.forEach((asset) => {
            let clusterString = "";
            asset.clusters.forEach((cluster, index) => {
                if(index) {
                    clusterString += `;${cluster}`;
                } else {
                    clusterString += cluster;
                }
            })
            res += `${asset.divertCode},${clusterString}\n`
        })
        return res;
    }
}

export const MHELogsCSVParser = {
    FIELDS: (intl) => {
        return `${getLocalizedMessage({intl, stringId: 'mhelog.datetime'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.protocol'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.devicetype'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.devicename'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.mac'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.ip'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.eventtype'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.message'})},` +
            `${getLocalizedMessage({intl, stringId: 'mhelog.payload'})}\n`
    },
    STRINGIFY: (intl, data, deviceType) => {
        let response = MHELogsCSVParser.FIELDS(intl);
        data.forEach((entry) => {
            response += MHELogsCSVParser.FILTER_DATA(entry.timestamp.replace(COMMA, EMPTY_STRING)) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.component) + `,` +
                MHELogsCSVParser.FILTER_DATA(deviceType) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.name) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.mac) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.ip) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.eventType) + `,` +
                MHELogsCSVParser.FILTER_DATA(entry.message) + `,` +
                MHELogsCSVParser.FILTER_DATA(escapeDoubleQuotes(JSON.stringify(entry.payload))) + `\n`;
        })
        return response;
    },
    FILTER_DATA: (data) => {
        return data !== undefined ? data : '';
    }
}


// WEBPACK FOOTER //
// ./src/components/util/Parsers.js